import {AxiosError} from 'axios'

import {useRefraQuery} from '@refra/modules/common/hooks'
import {ErrorResponse} from '@refra/modules/common/types'
import {logger} from '@refra/modules/common/utils'

interface useStaticPartComponentDetailQueryParams {
  plantUpmId: string
  kilnUpmId: string
  staticPartId: string
  componentId: number
  shutdownId?: number
  enabled?: boolean
}

export const useStaticPartComponentDetailQuery = ({
  plantUpmId,
  kilnUpmId,
  staticPartId,
  componentId,
  shutdownId,
  enabled = true
}: useStaticPartComponentDetailQueryParams) => {
  return useRefraQuery({
    queryKey: 'staticPartComponentDetail',
    retry: false,
    params: [{plantUpmId, kilnUpmId, staticPartId, componentId, shutdownId}],
    throwOnError: (error) => {
      const axiosError = error as AxiosError<ErrorResponse>
      const errorDetails =
        axiosError?.response?.data.detail ?? axiosError.message ?? axiosError.response?.status
      logger
        .context('useStaticPartComponentDetailQuery')
        .extras({errorDetails, plantUpmId, kilnUpmId})
        .error('Error occurred while fetching static part component detail.')

      return false
    },
    enabled
  })
}
